import _ from 'lodash';
import React, { PropTypes } from 'react';

import Chart from '../../../../../utils/components/Chart';
import safeToFixer from '../../charts/portfolio/analysis/utils/safeToFixer';
import isDecimalEqual from '../../charts/portfolio/analysis/utils/isDecimalEqual';
import getTestScoreHistogramData from '../getTestScoreHistogramData';
import message from '../../../../../utils/message';

const TestScoreHistogram = ({ scores, toFixedNum }) => {
  // 平均点
  const average = _.mean(scores);

  const {
    binData,
    min,
    max,
    width,
  } = getTestScoreHistogramData(scores);

  const plotLines
    = (average >= 0)
    ? [
      {
        value: average,
        zIndex: 10,
        color: '#000000',
        width: 1,
        label: {
          text: `クラス平均(${safeToFixer(average, toFixedNum)})`,
        },
      },
    ]
    : [];

  const options = {
    chart: {
      type: 'column',
      marginLeft: 72, // Keep all charts left aligned
      spacingTop: 20,
      spacingBottom: 20,
    },
    legend: {
      enabled: false,
    },
    title: {
      text: message.scoreDistribution,
      style: {
        fontSize: '24px',
      },
    },
    xAxis: {
      min,
      max,
      tickInterval: width,
      // 平均点
      plotLines,
      title: {
        text: message.score,
      },
    },
    yAxis: {
      // 小数禁止
      allowDecimals: false,
      min: 0,
      title: {
        text: message.numOfStudents,
      },
    },
    tooltip: {
      headerFormat: '',
      pointFormatter() {
        const selectedData = _.find(binData, ({ middle }) => isDecimalEqual(middle, this.x, 1));
        if (!selectedData) {
          return '';
        }

        const { bottom, top } = selectedData;
        const rangeMessage = (() => {
          if (bottom === min) {
            return `${top}点未満`;
          }

          if (top === max) {
            return `${bottom}点以上`;
          }

          return `${bottom}点以上 ${top}点未満`;
        })();
        return `<span style="color:${this.color}">${rangeMessage}</span><br /><b>${this.y}</b>人<br/>`;
      },
      shared: true,
    },
    series: [{
      name: 'Score',
      data: binData.map(({ middle, count }) => [middle, count]),
      pointPadding: 0,
      groupPadding: 0,
    }],
  };

  return <Chart options={options} />;
};

TestScoreHistogram.propTypes = {
  scores: PropTypes.arrayOf(PropTypes.number),
  toFixedNum: PropTypes.number,
};

TestScoreHistogram.defaultProps = {
  scores: [],
  toFixedNum: 2,
};

export default TestScoreHistogram;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/utils/components/TestScoreHistogram.js